import LineOptInImage from '../assets/line-opt-in-image.png';

import { Button } from '@release/guest_ui/Button';
import { Modal } from '@release/guest_ui/Modal';
import { Typography } from '@release/guest_ui/Typography';
import { foldModal, isModalOpen, ModalState } from '@release/shared/utils/modal';
import Image from 'next/image';
import Link from 'next/link';

export type LINEOptInModalState = ModalState<{
  lineInvitationLink: string;
  orgName: string;
  // 新規企業連携で、追加でLINE登録が必要な場合
  isAdditionalLine?: boolean;
}>;

type LINEOptInModalProps = {
  state: LINEOptInModalState;
};

export const LINEOptInModal: React.FC<LINEOptInModalProps> = ({ state }) => {
  return (
    <Modal
      isOpen={isModalOpen(state)}
      className="size-full max-h-full max-w-full rounded-none tab:max-h-[700px] tab:max-w-[700px] tab:rounded-md"
    >
      {foldModal(
        state,
        () => null,
        ({ lineInvitationLink, orgName, isAdditionalLine }) => (
          <div className="flex size-full flex-col items-center justify-center gap-y-16 px-6 py-8">
            <div className="relative min-h-40 w-full">
              <Image src={LineOptInImage} fill alt="LINE登録" className="object-contain" />
            </div>

            <div className="flex w-full flex-col items-center gap-y-6">
              {isAdditionalLine ? (
                <>
                  <Typography size="wolf" weight="bold" className="text-center">
                    LINE友だち追加が必要です
                  </Typography>
                  <Typography size="rabbit" className="text-center">
                    続いて、手続きに関する重要なお知らせを
                    <br />
                    LINEにお届けするため
                    <br />
                    {`${orgName}を友だち追加してください`}
                  </Typography>
                </>
              ) : (
                <>
                  <Typography size="wolf" weight="bold" className="text-center">
                    会員登録完了まで
                    <br />
                    あと少しです
                  </Typography>
                  <Typography size="rabbit" className="text-center">
                    手続きに関する重要なお知らせを
                    <br />
                    LINEにお届けするため
                    <br />
                    {`${orgName}を友だち追加してください`}
                  </Typography>
                </>
              )}
              <Link
                href={lineInvitationLink}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full max-w-[400px]"
              >
                <Button as="span" size="lg" label="友だち追加" className="w-full bg-other-brand-line" />
              </Link>
            </div>
          </div>
        )
      )}
    </Modal>
  );
};
